import Model from '../orm/Model'

export default class Import extends Model {
    
    static entity = 'imports'

    static fields() {
        return {
            id: this.attr(null),
            uuid: this.attr(null),
            status: this.attr(null),
            progress: this.number(0),
            created_at: this.attr(null)
        }
    }

    static graphql = {
        all: { },
        one: {
            parameters: {
                id: 'Int!'
            }
        }
    }
}